import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import store from './views/store'
import echarts from 'echarts'
import VueDND from 'awe-dnd'
Vue.prototype.$echarts = echarts

import Print from 'vue-print-nb'

//解决启动时报错依赖问题; add by zhaocl(2024-12-09)
import RelationGraph from 'relation-graph';
const { element, isFullscreen, off, on, toggle } = RelationGraph;

Vue.use(Print); //注册

Vue.config.productionTip = false
// 引用组件
Vue.use(ElementUI)
Vue.use(VueDND)

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
// 访问检测
router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})